
import React from "react";
import { Sidebar, SidebarContent, SidebarHeader, SidebarFooter } from "@/components/ui/sidebar";
import { DashboardNavItems } from "./DashboardNavItems";
import { Building } from "lucide-react";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

interface SidebarNavProps {
  activeTab: string;
  nursingHomeSlug?: string;
}

export function SidebarNav({ activeTab, nursingHomeSlug }: SidebarNavProps) {
  const navigate = useNavigate();
  
  // Handle navigation back to owner dashboard
  const handleBackToDashboard = () => {
    navigate("/owner/dashboard");
  };
  
  return (
    <Sidebar className="border-r h-full">
      <SidebarHeader className="p-4 border-b">
        <div className="flex items-center gap-2">
          <Building className="h-5 w-5 text-grandpal-green" />
          <h3 className="font-semibold">Owner Management</h3>
        </div>
      </SidebarHeader>
      
      <SidebarContent>
        <DashboardNavItems activeTab={activeTab} nursingHomeSlug={nursingHomeSlug} />
      </SidebarContent>
      
      <SidebarFooter className="p-4 border-t">
        <button 
          onClick={handleBackToDashboard}
          className={cn(
            "w-full py-2 px-3 flex items-center gap-2 text-sm rounded-md",
            "hover:bg-gray-100 transition-colors"
          )}
        >
          Back to Dashboard
        </button>
      </SidebarFooter>
    </Sidebar>
  );
}
